import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-debug-tool',
  template: `
    <div
      [ngClass]="{
        wrapper: subscription === 'debug-tool',
        wrapperSub: subscription !== 'debug-tool'
      }"
    >
      <debug-tool *axLazyElement></debug-tool>
    </div>
  `,
  styleUrls: ['../../app.component.scss'],
})
export class DebugToolComponent implements OnInit {
  subscription: string = '';
  constructor() {
    this.subscription = window.location.pathname.split('/')[1];
  }

  ngOnInit(): void {}
}
